// extracted by mini-css-extract-plugin
export default {"wrapper":"input-form-select_wrapper__9u3bE","error":"input-form-select_error__RhIBj"};